import React from "react";
import styled from "styled-components";

const Title = styled.div`  
  text-transform: uppercase;
  font-size: 20px;
  color: #999999;
  padding-bottom:10px;
  padding-top:10px;
  font-weight:400;
`;
const ChildSectionTitle = ({ id, children }) => (
  <Title id={id}>{children}</Title>
);
export default ChildSectionTitle;
